(function(){
  function clean(t){ return (t||'').replace(/\s+/g,' ').replace(/Regular price/gi,'').replace(/Sale price/gi,'').replace(/Unit price/gi,'').replace(/\s*\/\s*per\s*/gi,'').trim(); }
  function pickInfo(card){
    var infos = card.querySelectorAll('.card__information');
    if(!infos.length) return null;
    for(var i=infos.length-1;i>=0;i--){
      var el = infos[i];
      if(el.offsetParent !== null || el.getClientRects().length) return el;
    }
    return infos[infos.length-1];
  }
  function build(){
    var el = document.getElementById('ss-cc-data');
    if(!el) return;
    var map;
    try { map = JSON.parse(el.textContent); } catch(e){ return; }
    var cards = document.querySelectorAll('.card-wrapper');
    Array.prototype.forEach.call(cards, function(card){
      if(card.dataset.ssCc) return;
      var link = card.querySelector('a[href*="/products/"]');
      if(!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
      if(!m) return;
      var d = map[m[1]];
      if(!d) return;
      var info = pickInfo(card);
      if(!info) return;
      var href = link.getAttribute('href');
      var priceEl = card.querySelector('.price-item--regular') || card.querySelector('.price-item');
      var price = clean(priceEl ? priceEl.textContent : '');
      card.dataset.ssCc = '1';
      info.classList.add('ss-cc-info');

      var hit = card.querySelector('.card__inner') || card.querySelector('.card');
      if(hit && !hit.querySelector('.ss-cc-hit')){
        var overlay = document.createElement('a');
        overlay.className = 'ss-cc-hit';
        overlay.setAttribute('href', href);
        overlay.setAttribute('aria-label', d.n);
        hit.appendChild(overlay);
      }

      var wrap = document.createElement('div');
      wrap.className = 'ss-cc';
      var a = document.createElement('a');
      a.setAttribute('href', href);
      var row = document.createElement('div');
      row.className = 'ss-cc__row';
      var n = document.createElement('p');
      n.className = 'ss-cc__name';
      n.appendChild(document.createTextNode(d.n));
      if(d.d){
        var det = document.createElement('span');
        det.className = 'ss-cc__det';
        det.textContent = ', ' + d.d;
        n.appendChild(det);
      }
      row.appendChild(n);
      if(price){
        var pr = document.createElement('p');
        pr.className = 'ss-cc__price';
        pr.textContent = price;
        row.appendChild(pr);
      }
      a.appendChild(row);
      wrap.appendChild(a);
      info.appendChild(wrap);
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', build); } else { build(); }
  document.addEventListener('shopify:section:load', build);
  var grid = document.querySelector('#ProductGridContainer') || document.querySelector('main');
  if(grid && window.MutationObserver){ new MutationObserver(build).observe(grid, {childList:true, subtree:true}); }
})();
